/* This file is autogenerated, see readme.md for instructions */
import ColumnsSvgIcon from '@bloomreach/banana-theme/icons/columns.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const ColumnsIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <ColumnsSvgIcon />
    </Icon>
  );
});

ColumnsIcon.displayName = 'ColumnsIcon';

export default ColumnsIcon;
